export default "__VITE_ASSET__LRFfyRji__"